import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f084231a"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id", "name", "value", "checked"]
const _hoisted_2 = ["for"]
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 2,
  class: "badge"
}
const _hoisted_6 = { class: "text" }

interface Props {
	isActive: boolean;
	value: string;
	image: string;
	rawImage?: boolean;
	badge?: string;
	label: string;
	name: string;
	onInput: Function;
	activeValue: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'OptionSelector',
  props: {
    isActive: { type: Boolean },
    value: {},
    image: {},
    rawImage: { type: Boolean },
    badge: {},
    label: {},
    name: {},
    onInput: { type: Function },
    activeValue: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({
			'option-selector': true,
			'option-selector--active': _ctx.isActive,
		})
  }, [
    _createElementVNode("input", {
      class: "input",
      type: "radio",
      id: _ctx.value,
      name: _ctx.name,
      value: _ctx.value,
      onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onInput && _ctx.onInput(...args))),
      checked: _ctx.activeValue === _ctx.value
    }, null, 40, _hoisted_1),
    _createElementVNode("label", {
      for: _ctx.value,
      class: "label"
    }, [
      (_ctx.rawImage)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "image",
            innerHTML: _ctx.image
          }, null, 8, _hoisted_3))
        : (_openBlock(), _createElementBlock("img", {
            key: 1,
            class: "image",
            src: _ctx.image,
            alt: "",
            width: "140",
            height: "100"
          }, null, 8, _hoisted_4)),
      (_ctx.badge)
        ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.badge), 1))
        : _createCommentVNode("", true),
      _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.label), 1)
    ], 8, _hoisted_2)
  ], 2))
}
}

})